import type { SvgProps } from '@main/core-ui/src/Icon/constants/enums';
import React from 'react';

export const FileBlankCopy: React.FC<SvgProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      // eslint-disable-next-line max-len
      d="M10.666 12H11.9993C12.7357 12 13.3327 11.403 13.3327 10.6667V3.33333C13.3327 2.59695 12.7357 2 11.9993 2H5.99935C5.26297 2 4.66602 2.59695 4.66602 3.33333V4.66667"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M10.2389 6.31296L9.01908 5.09315C8.74559 4.81966 8.37465 4.66602 7.98788 4.66602H3.99935C3.26297 4.66602 2.66602 5.26297 2.66602 5.99935V12.666C2.66602 13.4024 3.26297 13.9993 3.99935 13.9993H9.33268C10.0691 13.9993 10.666 13.4024 10.666 12.666V7.34415C10.666 6.95738 10.5124 6.58645 10.2389 6.31296Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.666 7.66602H8.66602C8.11373 7.66602 7.66602 7.2183 7.66602 6.66602V4.66602"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
